<template>
  <div id="app" >
      <router-view class="view"></router-view>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        showLoading: false
      }
    },
    created () {
      window.$app = this
    },
    mounted () {
      let loading = document.getElementById('bowl-wrapper')
      if (loading.parentNode) {
        loading.parentNode.removeChild(loading)
      }
    }
  }
</script>

<style lang="less">
@import "./less/common.less";
</style>



// WEBPACK FOOTER //
// App.vue?c477924a